import { EMBRACE_EXPLORATIONS_HTML } from "./embraceExplorationsHtml";

/**
 * Design exploration surface (Feb 2026) — visual comparison of four
 * interaction models for the Engagement Embrace map. Public route so the
 * partner can share the link with anyone reviewing UX directions.
 *
 * Implementation note: the file was originally authored as a fully static
 * HTML document (see git history for /app/frontend/public/embrace-explorations.html).
 * The Kubernetes ingress in this preview routes every non-/api path into
 * the SPA and returns 404 for /public/*.html, so we serve the same
 * document via an iframe with `srcDoc` — no build-tool changes, no CSS
 * bleed into the rest of the app, no auth wall.
 */
export default function EmbraceExplorations() {
  return (
    <iframe
      title="Embrace Map · Interaction Explorations"
      srcDoc={EMBRACE_EXPLORATIONS_HTML}
      style={{ position: "fixed", inset: 0, width: "100vw", height: "100vh", border: 0 }}
      data-testid="embrace-explorations-frame"
    />
  );
}
